import { Entity } from "@hds/entity-lib";

class EventActivityEntity extends Entity {
    static DEFAULT_DOCUMENT = {
        onBlock: [],
        processedEntries: []
    };
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...EventActivityEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get eventType() {
        return this._virtualDataModel.getProperty('eventType');
    }
    set eventType(newEventType) {
        return this._virtualDataModel.setProperty('eventType', newEventType);
    }
    get onBlock() {
        return this._virtualDataModel.getProperty('onBlock');
    }
    set onBlock(ids) {
        this._virtualDataModel.setProperty('onBlock', ids)
    }
    get status() {
        return this._virtualDataModel.getProperty('status');
    }
    set status(newStatus) {
        return this._virtualDataModel.setProperty('status', newStatus);
    }
    get lastUpdatedRawEntryId() {
        return this._virtualDataModel.getProperty('lastUpdatedRawEntryId');
    }
    get processedEntries() {
        return this._virtualDataModel.getProperty('processedEntries');
    }
    appendEntry(newProcessedEventActivity) {
        if (!this._virtualDataModel.hasProperty('processedEntries')) {
            this._virtualDataModel.setProperty('processedEntries', []);
        }
        this.processedEntries.push(newProcessedEventActivity);
    }
    /*****************************************************/
    // END ENTITY DATA MODEL
    // START OVERRIDDEN METHODS
    /*****************************************************/
    clone() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

//META PROPERTIES
Object.defineProperty(EventActivityEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime',
        entityName: 'event-activity'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { EventActivityEntity };
export default EventActivityEntity;